<template>
  <div class="search-heading" v-if="shouldShow()">
    <h1>{{ formSearchHeading }}</h1>
  </div>
</template>

<script>
import { areWeInSearchPage } from '@/app/routes';
import utils from '@/app/utils/utils';
import config from '@/config';
import { getFeatureGroupById } from '@/config/featureGroups';
import cities from '@/utils/cities';
import useSafeRoute from '@/app/composables/useSafeRoute';

export default {
  name: 'search-heading',
  setup() {
    const route = useSafeRoute();
    return { route };
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  methods: {
    shouldShow() {
      return areWeInSearchPage(this.route.path);
    },
  },
  computed: {
    formSearchHeading() {
      const modePart = this.filters?.mode === config.SEARCH_MODES.RENTAL ? 'Vuokrattavat' : 'Myytävät';
      const typePart = getFeatureGroupById(this.filters?.featureGroup)?.name.toLowerCase();

      const pathParts = utils.splitPathToParts(this.route.path);
      const cityInUrl = pathParts.length === 3 && pathParts[2].length ? pathParts[2] : '';
      const cityToShow = cities.find((city) => utils.nameToPathFormat(city.name) === cityInUrl)?.name;

      return `${modePart} ${typePart} ${cityToShow ? `- ${cityToShow}` : ''}`;
    },
  },
};
</script>
